import randomatic from "randomatic";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { H2RButton, H2RInput, H2RSelect, cuesApi } from "../imports";
import OpenExternal from "./helpers/OpenExternal";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

export default function AddDataSource() {
	const [addingDataSource, setAddingDataSource] = useState(false);

	const selectedProject = useSelector(
		(state) => state.main?.settings?.selectedProject
	);
	const dataSources = useSelector((state) => state.main?.dataSources) || {};

	return (
		<>
			{Object.entries(dataSources).filter(([id, source]) =>
				source.addedToProjects?.includes(selectedProject)
			).length < 1 &&
				!addingDataSource && (
					<H2RButton
						text="Add data source"
						colour="light"
						icon={faPlus}
						onClick={() => {
							setAddingDataSource(true);
						}}
						size="small"
						css="mt-2 w-min whitespace-pre"
					/>
				)}
			{addingDataSource && (
				<NewDataSourceForm
					selectedProject={selectedProject}
					onCancel={() => {
						setAddingDataSource(false);
					}}
				/>
			)}
		</>
	);
}

const NewDataSourceForm = ({ selectedProject, onCancel }) => {
	const [dataType, setDataType] = useState("");
	const [youtubeId, setYouTubeId] = useState("");

	const youtubeAPIKey = useSelector(
		(state) => state.main?.settings?.youtube_api_key
	);

	const handleFormSubmit = async () => {
		if (dataType === "") return null;

		if (dataType === "youtube_live_chat") {
			await cuesApi.addDataSource(selectedProject, youtubeId, dataType, {
				youtubeId,
				name: "YouTube Live chat",
				type: dataType,
			});

			await cuesApi.connectToDataSource(youtubeId, "youtube");
		} else if (dataType === "http_listener") {
			cuesApi.addDataSource(selectedProject, randomatic("A0", 10), dataType, {
				name: "HTTP listener",
				type: dataType,
			});
		} else if (dataType === "http_poll") {
			cuesApi.addDataSource(selectedProject, randomatic("A0", 10), dataType, {
				name: "HTTP poll",
				type: dataType,
			});
		}

		return onCancel();
	};
	return (
		<form
			className="flex flex-col space-y-3 w-full"
			onSubmit={(e) => {
				return e.preventDefault();
			}}
		>
			<H2RSelect
				label="Source type"
				colour="light"
				selected={dataType}
				onChange={(change) => {
					return setDataType(change);
				}}
				options={[
					{
						label: "YouTube live chat",
						value: "youtube_live_chat",
					},
					{
						label: "HTTP Listener",
						value: "http_listener",
					},
					// {
					// 	label: "HTTP Poll",
					// 	value: "http_poll",
					// },
					// {
					// 	label: "H2R Graphics Cloud Interaction",
					// 	value: "cloud_interaction",
					// },
				]}
			/>
			{dataType === "youtube_live_chat" &&
				(youtubeAPIKey === undefined || youtubeAPIKey === "" ? (
					<span>First, enter your API key in Settings → Data Sources.</span>
				) : (
					<>
						<H2RInput
							label="YouTube video ID"
							value={youtubeId}
							onChange={(change) => {
								setYouTubeId(change);
							}}
							placeholder="1a2b3c4d"
							colour="light"
						/>
						<span className="text-xs select-text">
							<OpenExternal
								buttonText={"Learn how this works"}
								isElectronLink={`https://docs.h2r.graphics/control/data-source/youtube-live-chat`}
								isNotElectronLink={`https://docs.h2r.graphics/control/data-source/youtube-live-chat`}
							/>
						</span>
						{!/^[a-zA-Z0-9_-]{11}$/.test(youtubeId) && (
							<span className="text-sm">
								Only the YouTube video ID is needed.
								<br />
								<span className="p-0.5 text-xs bg-gray-800 rounded">
									https://www.youtube.com/watch?v=SWmmr4uvb1o
								</span>{" "}
								→{" "}
								<span className="p-0.5 text-xs bg-gray-800 rounded">
									SWmmr4uvb1o
								</span>
							</span>
						)}
					</>
				))}

			<div className="flex pt-1 space-x-3 justify-between">
				<H2RButton
					icon={faPlus}
					text="Add data source"
					css="w-min h-auto whitespace-pre"
					size="small"
					disabled={
						dataType === "youtube_live_chat" &&
						!/^[a-zA-Z0-9_-]{11}$/.test(youtubeId)
					}
					onClick={handleFormSubmit}
				/>
				<H2RButton
					text="Cancel"
					colour="dark"
					css="w-min h-auto whitespace-pre"
					size="small"
					onClick={onCancel}
				/>
			</div>
		</form>
	);
};
